var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "estudologia-arrow-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Custom-Preset",
    transform: "translate(-271.000000, -194.000000)",
    fill: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(53.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.565414,20.4739912 L216.708141,16.9381575 C216.446703,16.6981494 216.429131,16.2918499 216.669139,16.0295554 C216.908719,15.7676894 217.315447,15.7509745 217.577313,15.990554 L221,19.1282314 L224.422687,15.990554 C224.684553,15.7514031 225.091281,15.768118 225.330861,16.0295554 C225.570869,16.2918499 225.553297,16.6981494 225.291859,16.9381575 L221.434586,20.4739912 C221.311582,20.5867092 221.155577,20.642854 221,20.642854 C220.844423,20.642854 220.688418,20.5867092 220.565414,20.4739912 Z",
    id: "Fill-1-Copy-12",
    transform: "translate(221.000000, 18.232143) rotate(-90.000000) translate(-221.000000, -18.232143)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.aaf925c01658b8d2726793043a29a10f.svg";
export { ForwardRef as ReactComponent };